module.exports = __webpack_public_path__ + "static/img/8.fa31e58.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/1/sp/8.png
// module id = r3a7
// module chunks = 0